import styled from 'styled-components';

import bookSVG from '~images/instructions.svg';

import { Gap, Columns, Button } from '~ui-kit';

const Device = ({ device }) => {
  return (
    <>
      <Columns gap="0">
        <Details>
          <DetailsGrid>
            <Detail>Laitteen kustannuspaikka:</Detail>
            <Detail>{`${device?.costCentreCode} ${device?.costCentreTitle}`}</Detail>
            <Detail>Tarkempi sijainti:</Detail>
            <Detail>{device?.deviceLocation}</Detail>
            <Detail>Huoltoyksikkö:</Detail>
            <Detail>{device?.unitCodeName}</Detail>
          </DetailsGrid>
          {device?.instructionsUrl && (
            <>
              <Gap height="32px" />
              <a
                href={`${device?.instructionsUrl}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                <Instructions>
                  <span>Tutustu käyttöohjeisiin</span>
                  <Book src={bookSVG} />
                </Instructions>
              </a>
            </>
          )}
        </Details>
        <div />
      </Columns>
      <Gap />
    </>
  );
};

const Details = styled.div`
  margin-bottom: 48px;
  font-size: 16px;
`;

const DetailsGrid = styled.div`
  display: grid;
  grid-template-columns: auto auto;
  grid-gap: 16px;
  align-items: center;

  max-width: 480px;

  & > :nth-child(2n) {
    color: var(--primaryColor);
  }
`;

const Detail = styled.div`
  word-break: break-word;
`;

const Instructions = styled(Button)`
  padding-left: 32px;
  padding-right: 32px;
`;

const Book = styled.img`
  margin-left: 12px;
`;

export default Device;
